import { TweenMax } from 'gsap'

function getScrollY () {
  let doc = document.documentElement
  return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
}

const scrollObject = {}

function scrollTo (x, y, duration) {
  if (!duration) {
    duration = 0.8
  }
  scrollObject.y = getScrollY()
  TweenMax.to(scrollObject, duration, {
    y: y,
    onUpdate: function () {
      window.scrollTo(0, scrollObject.y)
    }
  })
}

export default {
  scrollTo,
  getScrollY
}
